"use strict";

import angular from "angular";
import 'angular-basic-app';
import "vt-misc/angular-seo";
import "angular-translate"
import "moment";

import "vt-misc/grid.css";
import "vt-misc/font.css";
import "vt-misc/app.scss";
import "vt-misc/tailwind.scss";
import "vt-misc/tailwind-adjustments.css";

import "oclazyload";
// route config
import angularSanitizeConfig from "angular-sanitize.config";
import angularTranslateConfig from "./angular-translate.config";
import angularHttpConfig from "./angular-http.config";
import baseRouteConfig from "./base-route.config";
import BicycleOwnerApp from "vt-bicycle-owner/bicycle-owner.module";
import OrganisationOwnerApp from "vt-organisation-owner/organisation-owner.module";
import ServiceProviderApp from "vt-service-provider/service-provider.module";
import AdminApp from "vt-admin/admin.module";
import PublicApp from "vt-public/public-app.module";

export default angular
  .module("velotooler-app", [
    'angular-basic-app',
    'seo',
    'oc.lazyLoad',
    'pascalprecht.translate',
    PublicApp.name,
    BicycleOwnerApp.name,
    OrganisationOwnerApp.name,
    ServiceProviderApp.name,
    AdminApp.name
  ])
  .config(baseRouteConfig)
  .config(angularSanitizeConfig)
  .config(angularTranslateConfig)
  .config(angularHttpConfig);
